import {Breadcrumbs, CircularProgress, Grid, Tooltip, Typography} from '@mui/material';
import PageTitle from '../../../common/PageTitle';
import HomeIcon from '@mui/icons-material/Home';
import LinkNavegacao from '../../../common/Link';
import CardOption from '../../../common/CardOption';
import { RequestServiceIcon } from '../../../common/Icons';
import { verifyUserAbilities } from '../../../config/functions';
import {useEffect, useState} from "react";
import {listaEmpresas} from "../../management/companies/configs/functions";
import {useModuleContext} from "../../../../contexts/ModuleProvider";

export function Retiradas() {
    const { getEmpresasPermissionsByModule } = useModuleContext();

    const [temEmpresaComModulo, setTemEmpresaComModulo] = useState(false);
    const [loadingModulo, setLoadingModulo] = useState(true);

    const [abilities, setAbilities] = useState({});
    const [loading, setLoading] = useState(true);

    const permissoesNecessarias = [
        { rota: "retiradas", title: "Registro de retiradas e requisições", description: "Realize retiradas e requisições online.", url: "registro" },
        { rota: "retiradas", title: "Retiradas", description: "Visualize as retiradas feitas.", url: "retiradas" },
        { rota: "retiradaExtra", title: "Retiradas Extras", description: "Visualize as retiradas extras feitas.", url: "retiradas_extras" },
        { rota: "devolucao", title: "Devolução de EPI's", description: "Registre devoluções de EPIs com eficiência. Acompanhe o histórico de devoluções, garantindo a segurança e a integridade dos equipamentos.", url: "devolucoes" },
    ];

    const permissoesFiltradas = permissoesNecessarias.filter(item => {
        if (item.url === "registro") {
            return temEmpresaComModulo;
        }
        return true;
    });

    useEffect(() => {
        const carregarPermissoes = async () => {
            const resultados = {};

            for (const item of permissoesNecessarias) {
                resultados[item.rota] = await verifyUserAbilities({ rota: item.rota });
            }

            setAbilities(resultados);
            setLoading(false);
        };

        carregarPermissoes();
    }, []);

    useEffect(() => {
        const carregaModulo = async () => {
            try {
                const response = await listaEmpresas(null, null, null, true);
                const todasEmpresas = response?.data?.data || [];

                const empresasComPermissao =
                    getEmpresasPermissionsByModule('Balcao', todasEmpresas);

                const empresasComContrato =
                    empresasComPermissao.filter(
                        empresa => empresa.idContrato != null
                    );

                setTemEmpresaComModulo(empresasComContrato.length > 0);
            } finally {
                setLoadingModulo(false);
            }
        };

        carregaModulo();
    }, []);

    if (loading || loadingModulo) {
        return (
            <Grid container justifyContent="center" alignItems="center" sx={{ height: "100vh" }}>
                <CircularProgress />
            </Grid>
        );
    }

    return (
        <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="stretch"
            spacing={3}
        >
            <Grid item xs={12}>
                <Breadcrumbs>
                    <LinkNavegacao to='/'><HomeIcon fontSize='small' /></LinkNavegacao>
                    <LinkNavegacao to='/epis'>Gestão de EPI's</LinkNavegacao>
                    <Typography variant='span'>Retiradas</Typography>
                </Breadcrumbs>

                <PageTitle icon={<RequestServiceIcon fontSize='large' />} title='Retiradas' />
            </Grid>

            {permissoesFiltradas.map((item) => {
                const temPermissao = abilities[item.rota]?.data.success;

                return (
                    <Grid
                        key={item.rota}
                        item
                        xs={12}
                        sm={6}
                        md={4}
                        lg={4}
                        xl={3}
                        sx={{
                            opacity: temPermissao ? 1 : 0.5,
                            pointerEvents: temPermissao ? 'auto' : 'none',
                        }}
                    >
                        <CardOption
                            title={item.title}
                            description={item.description}
                            url={item.url}
                            hasPermisson={temPermissao}
                        />
                    </Grid>
                );
            })}

        </Grid>
    );
}